module.exports = __webpack_public_path__ + "img/shield-disable.560b09ff.svg";